import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "name-input"
}, "Ihr Name* ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Bitte geben Sie ihren Namen an!", -1)
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "phone-number-input"
}, "Ihre Telefonnummer* ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Bitte geben Sie ihre Telefonnummer an!", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "Die Telefonnummer, unter der wir Sie erreichen können.", -1)
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "preferred-time-input"
}, "Rückrufzeitraum ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "An welchem Wochentag / zu welcher Uhrzeit können wir Sie am besten erreichen?", -1)
const _hoisted_11 = { class: "mb-2 form-check" }
const _hoisted_12 = {
  class: "form-check-label",
  for: "checkbox-tos"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Ich habe die Informationen in der ")
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" zur Datenverarbeitung bei Kontaktanfragen zur Kenntnis genommen.* ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Bitte akzeptieren Sie unsere AGB!", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "small" }, [
  /*#__PURE__*/_createElementVNode("i", null, "* Pflichtfeld")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    ref: "form",
    class: _normalizeClass({ 'was-validated': _ctx.formWasValidated }),
    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args))),
    onSubmit: _cache[9] || (_cache[9] = _withModifiers(()=>{}, ["stop","prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        id: "name-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.callbackFormData.name) = $event)),
        class: "form-control",
        minlength: "2",
        name: "name",
        placeholder: "Vor- und Nachname",
        required: "",
        type: "text",
        onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
      }, null, 544), [
        [_vModelText, _ctx.callbackFormData.name]
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        id: "phone-number-input",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.callbackFormData.phoneNumber) = $event)),
        class: "form-control",
        minlength: "4",
        name: "phone-number",
        placeholder: "Ihre Telefonnummer*",
        required: "",
        type: "text",
        onKeyup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
      }, null, 544), [
        [_vModelText, _ctx.callbackFormData.phoneNumber]
      ]),
      _hoisted_6,
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _withDirectives(_createElementVNode("input", {
        id: "preferred-time-input",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.callbackFormData.preferredTime) = $event)),
        class: "form-control",
        name: "preferred-time",
        placeholder: "Rückrufzeitraum",
        type: "text",
        onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
      }, null, 544), [
        [_vModelText, _ctx.callbackFormData.preferredTime]
      ]),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _withDirectives(_createElementVNode("input", {
        id: "checkbox-tos",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tosAccepted) = $event)),
        class: "form-check-input",
        name: "tos",
        required: "",
        type: "checkbox",
        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.formChanged && _ctx.formChanged(...args)))
      }, null, 544), [
        [_vModelCheckbox, _ctx.tosAccepted]
      ]),
      _createElementVNode("label", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("a", {
          href: _ctx.tosUrl,
          class: "",
          rel: "noopener",
          target: "_blank"
        }, "Datenschutzerklärung", 8, _hoisted_14),
        _hoisted_15
      ]),
      _hoisted_16
    ]),
    _hoisted_17
  ], 34))
}